<template>
    <div class="default-result">
        <div class="default-result-top">
            <div class="image">
                <img
                    src="../../../assets/images/student-loan-default.svg"
                    alt="LendingTree"
                />
            </div>
            <h3 class="result-title">
                Outsmart your student loan!
            </h3>
            <p class="result-description">
                Plug in a few quick numbers and we’ll do the rest.
            </p>
        </div>
        <div class="default-result-bottom">
            <p>
                Refinancing saves the average borrower thousands of dollars
                and you may even be able to make your monthly payments smaller.
                Now that's what we call win-win.
            </p>
        </div>
    </div>
</template>
<script>
    export default {};
</script>
